import React from 'react';
import { MessageSquare, Cpu, Smartphone, Lightbulb, Server } from 'lucide-react';
import theme from '../../constants/theme';

const services = [
  {
    icon: <MessageSquare size={36} style={{ color: theme.primary }} className="mb-6" />,
    title: 'Custom LLMs & GenAI',
    desc: 'Tailored language models, Retrieval-Augmented Generation (RAG) pipelines, and intelligent chatbots designed for your specific enterprise data.',
    span: '',
  },
  {
    icon: <Cpu size={36} style={{ color: theme.primary }} className="mb-6" />,
    title: 'Computer Vision',
    desc: 'Real-world visual intelligence. From object detection to complex automated visual inspection systems for industrial and commercial use.',
    span: '',
  },
  {
    icon: <Smartphone size={36} style={{ color: theme.primary }} className="mb-6" />,
    title: 'Edge & On-Device AI',
    desc: 'We optimize and deploy neural networks directly onto Android devices and edge hardware for zero-latency, offline inference.',
    span: '',
  },
  {
    icon: <Lightbulb size={36} style={{ color: theme.primary }} className="mb-6" />,
    title: 'AI Strategy & Consulting',
    desc: 'Guiding MNCs and startups on how to integrate AI effectively. We identify high-impact use cases and map out scalable architectures.',
    span: '',
  },
];

export default function Services() {
  return (
    <section id="services" className="py-24 border-y" style={{ borderColor: 'rgba(198, 6, 100, 0.1)' }}>
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-16">
          <h2 className="font-retropix text-3xl md:text-4xl mb-4" style={{ color: theme.primary }}>
            Our Expertise
          </h2>
          <p className="max-w-2xl mx-auto opacity-80">We don't just build models; we build deployable products.</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((s) => (
            <div
              key={s.title}
              className="p-8 border-2 transition-all hover:-translate-y-2 hover:shadow-lg"
              style={{ borderColor: 'rgba(26, 26, 26, 0.1)' }}
            >
              {s.icon}
              <h3 className="font-bold text-xl uppercase tracking-wide mb-3">{s.title}</h3>
              <p className="text-sm opacity-80 leading-relaxed">{s.desc}</p>
            </div>
          ))}

          {/* Featured wide card */}
          <div
            className="p-8 border-2 transition-all hover:-translate-y-2 hover:shadow-lg lg:col-span-2"
            style={{ borderColor: theme.primary }}
          >
            <div className="flex flex-col md:flex-row gap-6 items-start md:items-center">
              <Server size={48} style={{ color: theme.primary }} className="flex-shrink-0" />
              <div>
                <h3 className="font-bold text-xl uppercase tracking-wide mb-2" style={{ color: theme.primary }}>
                  End-to-End System Deployment
                </h3>
                <p className="text-sm opacity-90 leading-relaxed">
                  Research, design, development, evaluation, and deployment. We take your idea from a conceptual whiteboard architecture all the way to a live, scalable cloud or edge server API.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
